import * as api from '../api/client'

// Not currently in use. At the moment client profile create/update happens
// just in front end state and is not transmitted to the backend until the
// complete session call is made.  Leaving this here in case we decide to
// independently persist client info on server.
export const createOrUpdateClient = () => {
  return (dispatch, getState) => {
    let id = getState().client.id
    let apiCall = id ? api.updateClient : api.createClient
    apiCall(getState().form.clientProfile.values, id)
      .then(res => dispatch(setClient(res.data)))
  }
}

export const clientSaveChangesClicked = () => {
  return (dispatch, getState) => {
    dispatch(setClient(getState().form.clientProfile.values))
  }
}

const setClient = (clientData) => {
  return {
    type: 'SET_CLIENT',
    value: clientData
  }
}



// WEBPACK FOOTER //
// ./src/actions/client.js